export default __webpack_public_path__ + "static/media/hk33.d7954d38.svg";